// extracted by mini-css-extract-plugin
module.exports = {"title":"_2ajvG","rowTitle":"_21H_e","icons":"G_4Y7","icon":"_3zZfF"};